import { omit, sortBy, pick } from 'lodash-es'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { getTitle, getSummaryValue, makeFactorTable, makeFactorsLikeArrayObject } from '../utils'
import { getPredictionDataBySource } from '@/components/combined-predict/models/epiSuite/utils'

const summaryMapper = (item, meta) => {
  const model = item?.model

  const summaryValues = (meta.children ?? []).map((child) => {
    const value = getPredictionDataBySource(item, child.id)
    return getSummaryValue({ value, unit: child?.unit }, child?.name)
  })

  const factorLikeArray = makeFactorsLikeArrayObject(
    pick(model, ['TotalAir', 'TotalSludge', 'TotalBiodeg', 'TotalRemoval', 'FinalEffluent']),
  )

  return {
    values: summaryValues,
    tables: [makeFactorTable(factorLikeArray)],
  }
}

const descriptorsMapper = (item) => {
  const model = item?.model
  if (!model) return { tables: null }

  const factorLikeArray = makeFactorsLikeArrayObject(omit(model, 'CalculationVariables'))

  const factorLikeArrayWithTotalAtTheBottom = sortBy(factorLikeArray, (item) =>
    item.type?.toLowerCase().startsWith('total') ? 1 : 0,
  )
  const fullProcessBreakdownTable = makeFactorTable(factorLikeArrayWithTotalAtTheBottom, 'Full Process Breakdown')

  return {
    tables: [fullProcessBreakdownTable],
  }
}

const stpWin = (items) => {
  const item = items?.find((item) => item?.property === 'sewageTreatmentModel')
  const meta = findEpiSuiteGroupById('sewageTreatmentModel')

  return {
    title: getTitle(meta),
    description: 'Sewage Treatment Plant Removal',
    helpPage: meta?.helpPage,
    summary: summaryMapper(item, meta),
    modelDescriptors: descriptorsMapper(item),
    modelOutput: item?.output,
  }
}

export { stpWin }
